import useId from '../utils/useId';
import * as React from 'react';
export const supabaseSvg = React.forwardRef(function supabaseSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F4F7FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.194 28.912c-.682.86-2.066.388-2.082-.709l-.24-16.045H26.66c1.954 0 3.044 2.257 1.83 3.788L18.193 28.912Z',
      fill: `url(#bi_supabase__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.194 28.912c-.682.86-2.066.388-2.082-.709l-.24-16.045H26.66c1.954 0 3.044 2.257 1.83 3.788L18.193 28.912Z',
      fill: `url(#bi_supabase__b_${id_1})`,
      fillOpacity: 0.2,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.806 3.094c.682-.86 2.066-.389 2.082.708l.105 16.046H5.34c-1.955 0-3.044-2.258-1.83-3.788L13.807 3.094Z',
      fill: '#3ECF8E',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_supabase__a_${id_0}`,
          x1: 15.872,
          y1: 15.716,
          x2: 25.46,
          y2: 19.737,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#249361',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#3ECF8E',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_supabase__b_${id_1}`,
          x1: 11.62,
          y1: 9.895,
          x2: 15.993,
          y2: 18.127,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', null),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopOpacity: 0,
        }),
      ),
    ),
  );
});
supabaseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var supabase = {
  category: 'brand',
  colorable: false,
  name: 'supabase',
  svg: supabaseSvg,
};
